import { Component } from 'react'
import PropTypes from 'prop-types'

import InputTextField from 'components/common/InputTextField'
import Button from 'components/common/Button'
import DividerWithText from 'components/common/DividerWithText'
import SSOButton from 'components/authentication/form-fields/SSOButton'
import logoGoogle from 'assets/logos/google.svg'
import logoSAML from 'assets/logos/saml.svg'

export default class Password extends Component {
  static propTypes = {
    password: PropTypes.string,
    submitForm: PropTypes.func,
    handleChange: PropTypes.func,
    handleSaml: PropTypes.func,
    handleGoogle: PropTypes.func,
    inputIsDisabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    signInMethods: PropTypes.array,
    googleText: PropTypes.string
  }

  render() {
    const {
      handleGoogle = () => {},
      handleSaml = () => {},
      googleText,
      signInMethods: methods,
      inputIsDisabled,
      handleChange,
      password,
      isLoading
    } = this.props

    return (
      <div className="formFields">
        {methods.includes('password') && (
          <div className="formFields">
            <InputTextField
              data-test-password-input
              disabled={inputIsDisabled}
              innerRef={this.setRef}
              label="Password"
              name="password"
              type="password"
              value={password}
              onChange={handleChange}
            />
            <Button
              data-test-password-continue-button
              stretch
              disabled={!password.length || isLoading}
              label="Continue"
              type="submit"
            />
          </div>
        )}
        {methods.includes('password') && methods.length > 1 && (
          <DividerWithText />
        )}
        {methods.includes('google') && (
          <SSOButton
            alt="Google"
            logo={logoGoogle}
            text={googleText || 'Log in with Google'}
            onClick={handleGoogle}
          />
        )}
        {methods.includes('saml') && (
          <SSOButton
            data-test-saml-signin
            alt="SAML"
            logo={logoSAML}
            text="Log in with SAML"
            onClick={handleSaml}
          />
        )}
      </div>
    )
  }
}
